<template>
  <div class="main-wrapper sidebar-layout">
    <div class="layout-part-sidebar">
      <Sidebar />
    </div>
    <div class="layout-part-content p-0">
      <template v-if="!isDataLoading">
        <ReportHead />
        <MainProperties />

        <div v-if="parsedData" class="reports-content">
          <ViewsBreakdown class="mb-5" />
          <DeviceBreakdown class="mb-5" />
          <TotalReviews class="mb-5" />
          <LineChart data-type="average_review_rating" class="mb-5">Average review rating</LineChart>
          <div v-if="gbEnabled">
            <h2 class="h3 m-0 mb-3 font-weight-semi-bold color-dark">Moments</h2>
            <LineChart data-type="published_checkins" class="mb-5">
              Published moments
            </LineChart>

            <CheckinsCategories class="mb-5" />
          </div>
          <LineChart data-type="local_posts" class="mb-5">Local Posts</LineChart>
          <ImagesCount class="mb-5" />
          <LineChart data-type="questions" class="mb-5">Questions</LineChart>
          <LineChart data-type="answered_questions" class="mb-5">Answered questions</LineChart>
          <SearchKeyword class="mb-5" />
          <MapsSearchGeogrids />
        </div>

        <div v-else class='alert alert-info' role='alert'>
          <div class='message my-1'>
            Summary data for all locations is shown in the report only if the comparison period is not set to Baseline
            or if all locations were activated on the same day.
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Sidebar from './sidebar'
import ReportHead from './report_head'
import MainProperties from './main_properties'
import ViewsBreakdown from './views_breakdown'
import DeviceBreakdown from './device_breakdown'
import TotalReviews from './total_reviews'
import ImagesCount from './images_count'
import SearchKeyword from './search_keyword'
import MapsSearchGeogrids from './maps_search_geogrids'
import LineChart from './line_chart'
import CheckinsCategories from './checkins_categories'

export default {
  components: {
    Sidebar,
    ReportHead,
    MainProperties,
    ViewsBreakdown,
    DeviceBreakdown,
    TotalReviews,
    ImagesCount,
    SearchKeyword,
    MapsSearchGeogrids,
    LineChart,
    CheckinsCategories
  },
  created() {
    this.fetchInsights()
  },
  computed: mapState(['isDataLoading', 'gbEnabled', 'parsedData']),
  methods: mapActions(['fetchInsights'])
}
</script>
